<script>
import {addFormData, getFormData} from "@/api/apply-api";

export default {
  name: "LauncherFormSettingView",
  data() {
    return {
      bookFormOrigin: null,
      inviteFormOrigin: null,

      bookFormSetting: [],
      inviteFormSetting: [],

      activeName: "first",

    }
  },
  mounted() {
    this.setupPage()
  },

  methods: {
    setupPage() {
      console.log("setupPage")
      //       apiType: "", // BOOK_APPLY，INVITE_APPLY
      getFormData("BOOK_APPLY").then(({data}) => {
        console.log("getFormData BOOK_APPLY", data)
        if (data.code === 200 && data.data && data.data.formItems) {
          this.bookFormOrigin = data.data
        }
        this.dealApplyData()
      }).catch((err) => {
        console.log("getFormData err", err)
      })
      getFormData("INVITE_APPLY").then(({data}) => {
        console.log("getFormData INVITE_APPLY", data)
        if (data.code === 200 && data.data && data.data.formItems) {
          this.inviteFormOrigin = data.data
        }
        this.dealInventData()
      }).catch((err) => {
        console.log("getFormData err", err)
      })
    },

    dealInventData() {
      let forms = []
      this.inviteFormOrigin.formItems.forEach((item) => {
        if (item.valueList) {
          this.$set(item, "valueListArr", JSON.parse(item.valueList))
          item.valueListArr.forEach((valueItem) => {
            if (!valueItem.value_en) {
              this.$set(valueItem, "value_en", "")
            }
            if (valueItem.readyValue && !valueItem.readyValue_en) {
              this.$set(valueItem, "readyValue_en", "")
            }
          })
        }
        forms.push(item)
      })
      this.inviteFormSetting = forms
      console.log("dealInventData", this.inviteFormSetting)

    },

    dealApplyData() {
      let forms = []
      this.bookFormOrigin.formItems.forEach((item) => {
        if (item.valueList) {
          this.$set(item, "valueListArr", JSON.parse(item.valueList))
          item.valueListArr.forEach((valueItem) => {
            if (!valueItem.value_en) {
              this.$set(valueItem, "value_en", "")
            }
            if (valueItem.readyValue && !valueItem.readyValue_en) {
              this.$set(valueItem, "readyValue_en", "")
            }
          })
        }
        forms.push(item)
      })
      this.bookFormSetting = forms

      console.log("dealApplyData", this.bookFormSetting)
    },

    saveInventSetting() {
      let inventFormOrigin = Object.assign({}, this.inviteFormOrigin)
      this.inviteFormSetting.forEach((item) => {
        if (item.valueListArr) {
          item.valueList = JSON.stringify(item.valueListArr)
        }
      })
      inventFormOrigin.formItems = this.inviteFormSetting
      console.log("inventFormOrigin", inventFormOrigin)
      addFormData(inventFormOrigin).then(({data}) => {
        console.log("addFormData", data)
        if (data.code === 200) {
          this.$message.success("保存成功")
        } else {
          this.$message.error("保存失败")
        }
      }).catch((err) => {
        console.log("addFormData err", err)
      })

    },

    saveApplySetting() {
      let bookFormOrigin = Object.assign({}, this.bookFormOrigin)
      this.bookFormSetting.forEach((item) => {
        if (item.valueListArr) {
          item.valueList = JSON.stringify(item.valueListArr)
        }
      })
      bookFormOrigin.formItems = this.bookFormSetting
      console.log("bookFormOrigin", bookFormOrigin)
      addFormData(bookFormOrigin).then(({data}) => {
        console.log("addFormData", data)
        if (data.code === 200) {
          this.$message.success("保存成功")
        } else {
          this.$message.error("保存失败")
        }
      }).catch((err) => {
        console.log("addFormData err", err)
      })
    },


  }, // methods
}
</script>

<template>
  <div>
    <div class="nav">
      <el-radio-group v-model="activeName">
        <el-radio-button class="nav-item" label="first" border>预约表单</el-radio-button>
        <el-radio-button class="nav-item grayBg" label="second" border>邀约表单</el-radio-button>
      </el-radio-group>
    </div>
    <div class="h-4"></div>
    <div v-if="activeName === 'first'">
      <el-table :data="bookFormSetting" stripe border key="0">
        <el-table-column type="expand">
          <template slot-scope="props">
            <el-table :data="props.row.valueListArr"  v-if="props.row.valueListArr" stripe border class="ml-12" size="small">
              <el-table-column prop="value" label="中文选项值" width="180"></el-table-column>
              <el-table-column prop="value_en" label="英文选项值" width="200">
                <template slot-scope="scope">
                  <el-input v-model="scope.row.value_en"></el-input>
                </template>
              </el-table-column>
              <!--              <el-table-column prop="readyValue" label="依赖值" width="200"></el-table-column>-->
              <!--              <el-table-column prop="readyValue_en" label="依赖值英文" width="400">-->
              <!--                <template slot-scope="scope">-->
              <!--                  <el-input v-model="scope.row.readyValue_en"></el-input>-->
              <!--                </template>-->
              <!--              </el-table-column>-->
            </el-table>
          </template>
        </el-table-column>
        <el-table-column prop="title" label="中文标题" width="200"></el-table-column>
        <el-table-column prop="title_en" label="英文标题" width="400">
          <template slot-scope="scope">
            <el-input v-model="scope.row.title_en"></el-input>
          </template>
        </el-table-column>
      </el-table>
      <div class="p-4 text-center" style="width:  600px">
        <el-button class="w-40" type="primary" @click="saveApplySetting">保存</el-button>
      </div>
    </div>
    <div v-else>
      <el-table :data="inviteFormSetting" stripe border>
        <el-table-column type="expand">
          <template slot-scope="props" >
            <el-table :data="props.row.valueListArr" stripe border class="ml-12" v-if="props.row.valueListArr" size="small">
              <el-table-column prop="value" label="中文选项值" width="180"></el-table-column>
              <el-table-column prop="value_en" label="英文选项值" width="200">
                <template slot-scope="scope">
                  <el-input v-model="scope.row.value_en"></el-input>
                </template>
              </el-table-column>
<!--              <el-table-column prop="readyValue" label="依赖值" width="200"></el-table-column>-->
<!--              <el-table-column prop="readyValue_en" label="依赖值英文" width="400">-->
<!--                <template slot-scope="scope">-->
<!--                  <el-input v-model="scope.row.readyValue_en"></el-input>-->
<!--                </template>-->
<!--              </el-table-column>-->
            </el-table>
          </template>
        </el-table-column>
        <el-table-column prop="title" label="中文标题" width="200"></el-table-column>
        <el-table-column prop="title_en" label="英文标题" width="400">
          <template slot-scope="scope">
            <el-input v-model="scope.row.title_en"></el-input>
          </template>
        </el-table-column>
      </el-table>
      <div class="p-4 text-center" style="width:  600px">
        <el-button class="w-40" type="primary" @click="saveInventSetting">保存</el-button>
      </div>
    </div>
  </div>

</template>

<style scoped lang="less">
.nav {
  //padding-left: 10px;
  //padding-bottom: 10px;
  //background-color: #efefef;

  .nav-item {
    margin-right: 15px;
  }
}

//.grayBg {
//
//}

/deep/ .el-radio-button__inner {
  background-color: #efefef;
}

::v-deep .el-radio-button:first-child .el-radio-button__inner {
  border-radius: 60px;

}

::v-deep .el-radio-button:last-child .el-radio-button__inner {
  border-radius: 60px;
}

</style>
